export const onFiltersChanged = "ON_FILTERS_CHANGED";

export default function payonentryReducer(state, { payload, type }) {
  switch (type) {
    case onFiltersChanged:
      return { ...state, ...payload };
    default:
      return state;
  }
}